import React from 'react';
import { observer } from 'mobx-react-lite';
import { toDateTimeQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditDateTime } from './edit/EditDateTime';
import { ViewDateTime } from './view/ViewDateTime';
export const DateTime = observer(({
  id,
  questionStore,
  displayMode
}) => {
  const currentAnswer = toDateTimeQuestionAnswerOrEmpty(questionStore.currentAnswer);
  const showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
    return /*#__PURE__*/React.createElement(EditDateTime, {
      id: id,
      dateValue: currentAnswer.date,
      timeValue: currentAnswer.time,
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
      onDateChange: value => {
        questionStore.setAnswer({
          date: value,
          time: toDateTimeQuestionAnswerOrEmpty(questionStore.currentAnswer).time
        });
      },
      onTimeChange: value => {
        questionStore.setAnswer({
          date: toDateTimeQuestionAnswerOrEmpty(questionStore.currentAnswer).date,
          time: value
        });
      },
      label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
    });
  }
  return /*#__PURE__*/React.createElement(ViewDateTime, {
    id: id,
    dateValue: currentAnswer.date,
    timeValue: currentAnswer.time,
    displayMode: displayMode
  });
});